import { z } from "zod";

export const validationError = z.object({
  validationError: z.string(),
  validationErrorDetails: z.string().nullish(),
});

export type ValidationError = z.infer<typeof validationError>;
